import styled from 'styled-components';

export const GovNumVinPopupContainer = styled.div`
  .title {
    display: block;
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0 8px 0;
  }

  .report,
  .show-number {
    padding: 24px;
    font-size: 12px;
    flex: 1;
    border-radius: 4px;
    min-width: 281px;
    min-height: 224px;
    box-sizing: border-box;
    line-height: 1.5;
    transition: background-color 0.3s ease;

    &:hover {
      background: #e8f4ff;
    }

    .custom-badge {
      background: #478cc8;
    }

    .custom-badge-unactive {
      background: #596e81;
    }
  }

  .report {
    margin-right: 16px;

    @media (max-width: 647px) {
      margin: 0 0 16px 0;
    }
  }

  .checks-show-number {
    padding: 24px;
    border-radius: 4px;
    border: 1px solid #478cc8;
    background: #e8f4ff;
  }

  .badge-description {
    margin-left: 8px;
    color: #8c969d;
    font-size: 11px;
  }

  .list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .description {
    margin-top: 10px;
    font-size: 12px;
  }
`;

export const Tabs = styled.div`
  display: flex;

  @media (max-width: 647px) {
    flex-direction: column;
    margin: 0 0 16px 0;
    width: 100%;
    min-width: inherit;
  }
`;

export const Tab = styled.div<{ active: boolean; id: any }>`
  outline: none;
  cursor: pointer;
  position: relative;
  background-color: ${({ active }) => (active ? '#e8f4ff' : '')};
  border: ${({ active }) => (active ? '1px solid #478CC8' : '1px solid #dddfe1')};
`;

export const Content = styled.div<{ active: boolean }>`
  ${({ active }) => (active ? '' : 'display:none')}
`;

export const ContentTabs = styled.div`
  margin: 36px 0 10px 0;

  @media (max-width: 647px) {
    margin: 16px 0 0 0;
  }
`;

export const ReportButtonContainer = styled.div`
  margin-top: 35px;
`;
